import React, { useEffect, useRef, useState } from "react";
import { Modal, Checkbox, FormControlLabel } from "@mui/material";
import { Worker, Viewer } from "@react-pdf-viewer/core";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "./Policy.css";

const Policy = ({handleOnclickSubmit, open, onClose, pdfFile, heading, buttonTitle, isPolicyFirst }) => {
  const [checked, setChecked] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, onClose]);
  return (
    <Modal open={open} onClose={onClose}>
      <div className="policy-modal-overlay">
        <div className="policy-modal-content" ref={modalRef}>
          <div className="policy-modal-header">
            <div className="heading-title">{heading}</div>
          </div>

          <div className="pdf-viewer-container">
            {pdfFile ? (
              <Worker workerUrl="/pdf.worker.min.js">
                <Viewer fileUrl={pdfFile} />
              </Worker>
            ) : (
              <p>No PDF to display</p>
            )}
          </div>

          <div className="policy-footer">
            {isPolicyFirst && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                    style={{ color: "#FD8238" }}
                  />
                }
                label="I have read and agree to the policy"
              />
            )}
            <div className="button-container">
              <button
                disabled={isPolicyFirst && !checked}
                onClick={handleOnclickSubmit}
                className="submit-policy-btn"
                style={{
                  backgroundColor: isPolicyFirst && !checked ? "#F2B79E" : "#FD8238",
                  color: "#fff",
                }}
              >
                {isPolicyFirst ? "Accept & Continue" : "Close"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Policy;
